export function useContrastMode() {
  return useCookie('contrastMode', { default: () => false })
}

export type FontSize = 'small' | 'medium' | 'large'

export function useFontSize() {
  return useCookie<FontSize>('fontSize', { default: () => 'small' })
}
